module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    attrs: {
      "id": "updatedAvatar"
    }
  }, [_c('div', {
    staticClass: "updatedHead"
  }, [_vm._v("\n            头像上传"), _c('s', {
    on: {
      "click": _vm.closeAvatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "updatedContent"
  }, [_c('div', {
    staticClass: "updatedLeft"
  }, [_c('div', {
    style: ({
      backgroundSize: _vm.scale * 240 + 'px'
    }),
    attrs: {
      "id": "upImg"
    },
    on: {
      "mousedown": function($event) {
        _vm.moveImg($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photoFrame"
  }, [_c('span', {
    staticClass: "reduce",
    on: {
      "click": _vm.reduce
    }
  }, [_c('span')]), _vm._v(" "), _c('span', {
    staticClass: "slide-big"
  }, [_c('i', {
    staticClass: "slide-sm",
    style: ({
      left: (_vm.scale - 1) * 47 + 'px'
    }),
    attrs: {
      "id": "slide"
    },
    on: {
      "mousedown": function($event) {
        _vm.scaleBar($event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "increase",
    on: {
      "click": _vm.increase
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "updatedRight"
  }, [_c('p', [_vm._v("头像预览")]), _vm._v(" "), _c('div', {
    style: ({
      backgroundSize: _vm.scale * 120 + 'px'
    }),
    attrs: {
      "id": "sm_pic"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upText"
  }, [_c('span', {
    staticClass: "file"
  }, [_c('input', {
    ref: "img",
    attrs: {
      "id": "doc",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.changeSuccess($event)
      }
    }
  }), _vm._v("选择图片")]), _c('span', {
    staticClass: "format"
  }, [_vm._v("支持JPG、JPEG、PNG,小于2M")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-group"
  }, [_c('span', {
    staticClass: "bottom-btn1",
    on: {
      "click": _vm.closeAvatar
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "bottom-btn2",
    on: {
      "click": _vm.updatedSuccess
    }
  }, [_vm._v("保存")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-316393ce!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/upAvatar.vue
// module id = 718
// module chunks = 1